import { render, staticRenderFns } from "./news11.vue?vue&type=template&id=9a35fc48&scoped=true&"
import script from "./news11.vue?vue&type=script&lang=js&"
export * from "./news11.vue?vue&type=script&lang=js&"
import style0 from "./news11.vue?vue&type=style&index=0&id=9a35fc48&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a35fc48",
  null
  
)

export default component.exports